import { MultilingualWidgetConfig } from '../dashboard.widgets.config';

interface MedicationData {
  priority: {
    en: string;
    de: string;
  };
  patient: {
    name: {
      en: string;
      de: string;
    };
    room: {
      en: string;
      de: string;
    };
  };
  instruction: {
    en: string;
    de: string;
  };
  procedureTitle: {
    en: string;
    de: string;
  };
  procedureSteps: {
    en: string[];
    de: string[];
  };
}

// Medication instructions data
const medicationData: MedicationData = {
  priority: {
    en: 'HIGH PRIORITY',
    de: 'HOHE PRIORITÄT',
  },
  patient: {
    name: {
      en: 'Emma Wilson',
      de: 'Emma Wagner',
    },
    room: {
      en: 'Room 302',
      de: 'Zimmer 302',
    },
  },
  instruction: {
    en: 'Administer 10mg of Morphine IV at 15:00. Verify with second nurse.',
    de: 'Verabreichen Sie 10mg Morphin IV um 15:00 Uhr. Überprüfung durch zweite Pflegekraft erforderlich.',
  },
  procedureTitle: {
    en: 'Standard Procedure:',
    de: 'Standardverfahren:',
  },
  procedureSteps: {
    en: [
      'Verify patient identity using two identifiers',
      'Check medication against order',
      'Document administration in EMR',
      'Monitor patient for 30 minutes after administration',
      'Report any adverse reactions immediately',
    ],
    de: [
      'Patientenidentität mit zwei Identifikatoren überprüfen',
      'Medikation gegen Verordnung prüfen',
      'Verabreichung in elektronischer Patientenakte dokumentieren',
      'Patient 30 Minuten nach Verabreichung überwachen',
      'Unerwünschte Reaktionen sofort melden',
    ],
  },
};

const generateMedicationInstructionsContent = (lang: 'en' | 'de'): string => {
  // Generate procedure steps as list items
  const procedureStepsHtml = medicationData.procedureSteps[lang]
    .map(step => `<li>${step}</li>`)
    .join('');

  return `
    <div style="display: flex; flex-direction: column; height: 100%;">
      <div style="display: flex; align-items: center; margin-bottom: 12px;">
        <div style="width: 12px; height: 12px; background-color: #ef4444; border-radius: 50%; margin-right: 8px;"></div>
        <div style="font-weight: 600; color: #282a32;">
          ${medicationData.priority[lang]}
        </div>
      </div>
      <div style="background-color: #ecf3fe; border-left: 4px solid #434ce8; padding: 12px; margin-bottom: 12px; border-radius: 8px;">
        <div style="font-weight: 600; margin-bottom: 6px; color: #282a32;">
          Patient: ${medicationData.patient.name[lang]} (${medicationData.patient.room[lang]})
        </div>
        <div style="color: #686b87;">
          ${medicationData.instruction[lang]}
        </div>
      </div>
      <div style="margin-top: 12px;">
        <div style="font-weight: 600; color: #686b87; margin-bottom: 6px;">
          ${medicationData.procedureTitle[lang]}
        </div>
        <ol style="margin-top: 8px; padding-left: 20px; color: #282a32;">
          ${procedureStepsHtml}
        </ol>
      </div>
    </div>`;
};

export const medicationInstructionsWidget: MultilingualWidgetConfig = {
  id: 'medication-instructions',
  translations: {
    en: {
      title: 'Medication Instructions',
      content: generateMedicationInstructionsContent('en'),
    },
    de: {
      title: 'Medikationsanweisungen',
      content: generateMedicationInstructionsContent('de'),
    },
  },
  x: 4,
  y: 0,
  w: 2,
  h: 4,
};
